<template>
  <div
    v-if="uuid"
    :class="[
      'promoCode',
      status.type && `promoCode--${status.type}`
    ]">
    <div class="promoCode__container">
      <strong class="promoCode__label">Código promocional</strong>
      <input
        class="promoCode__code"
        type="text"
        v-model="code"
        :disabled="asyncPending"
      />
      <span v-if="status.text" class="promoCode__status">{{ status.text }}</span>
    </div>
    <button
      id="btn-ativar-cupom-portateis"
      class="promoCode__btn"
      type="button"
      :disabled="!code || isChecked"
      @click.prevent="validation"
    >
      ATIVAR
    </button>
  </div>
</template>
<script>
import { getPromoCode } from '@/api/services.js'

export default {
  name: 'PromoCode',
  props: {
    uuid: {
      type: String,
      required: true
    },
    isRenovation: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      asyncPending: false,
      code: null,
      isChecked: false,
      status: {},
      statusList: [
        {
          type: 'error',
          text: 'Código promocional inválido',
          isValid: false
        },
        {
          type: 'loading',
          text: 'Verificando código promocional...'
        },
        {
          type: 'success',
          text: 'Cupom ativado com sucesso!',
          isValid: true
        }
      ]
    }
  },
  watch: {
    code (newValue, oldValue) {
      if (!this.isChecked || newValue === oldValue) return

      if (this.status.isValid) {
        this.$emit('canceled', true)
      }

      this.status = {}
      this.isChecked = false
    },
    uuid (val) {
      const { promoCode } = this.$route.query || this.params
      const coupon = sessionStorage.getItem('coupon')

      if (val && promoCode) {
        this.code = promoCode.toUpperCase()
        this.validation()
      }

      if (val && coupon && !promoCode) {
        this.code = coupon.toUpperCase()
        this.validation()
      }
    }
  },
  mounted () {
    this.checkUrlPromoCode()
  },
  methods: {
    checkUrlPromoCode () {
      const { uuid, id, promoCode } = this.$route.query || this.params

      if (!uuid && !this.uuid && id) {
        this.uuid = id
      }

      if (promoCode) {
        this.code = promoCode.toUpperCase()
      }

      if (this.uuid && this.code) {
        this.validation()
      }
    },
    async validation () {
      const params = {
        uuid: this.uuid,
        promoCode: this.code.replace(/ /g, ''),
        isRenovation: this.isRenovation
      }

      this.asyncPending = true
      this.status = this.statusList[1]

      await getPromoCode(params)
        .then(response => {
          if (!response.data || !response.data.DEFAULT || !response.data.PROMO) {
            this.$sentry.logWithContext({
              ctx: { step: '[promoCode]: error data', data: response },
              error: new Error('[promoCode]: error data')
            })
            this.validationError()
            return
          }

          this.status = this.statusList[2]

          this.$emit('applied', {
            ...response.data,
            promoCode: this.code
          })

          window.dataLayer.push({
            event: 'dispositivos-ciclic',
            categoria: 'promocode-valido',
            acao: 'click',
            rotulo: this.code.toUpperCase()
          })

          this.isChecked = true
        })
        .catch(error => {
          if (error.response.status !== 404) {
            this.$sentry.logWithContext({
              ctx: { step: '[promoCode]: error' }, error
            })
          }

          this.validationError()
        })

      this.asyncPending = false
    },
    validationError () {
      this.status = this.statusList[0]

      window.dataLayer.push({
        event: 'dispositivos-ciclic',
        categoria: 'promocode-inválido',
        acao: this.status.text,
        rotulo: this.code.toUpperCase()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .promoCode {
    display: flex;
    margin-bottom: 12px;
    margin-top: 21px;

    @media screen and (max-width: 374px) {
      flex-flow: column;
    }

    &__container {
      display: flex;
      flex-flow: column;
      margin-right: 14px;
      width: 100%;

      @media screen and (min-width: 375px) {
        max-width: 320px;
        padding-bottom: 26px;
        position: relative;
      }
    }

    &__label {
      color: #595959;
      font-family: Oscine;
      font-size: 16px;
      margin-bottom: 8px;
    }

    &__code {
      background-color: #ffffff;
      border: 1px solid #bdc2c6;
      border-radius: 8px;
      color: #444444;
      font-family: Rubik;
      font-size: 16px;
      font-weight: 500;
      line-height: inherit;
      outline: 0;
      padding: 8px 16px;
      text-transform: uppercase;

      .promoCode--success & {
        border-color: #00cc67;
      }

      .promoCode--error & {
        border-color: #ff3b30;
      }
    }

    &__status {
      color: #444444;
      font-family: Rubik;
      font-size: 12px;
      font-weight: 500;

      @media screen and (max-width: 374px) {
        margin-top: 8px;
      }

      @media screen and (min-width: 375px) {
        bottom: 0;
        position: absolute;
      }

      .promoCode--loading & {
        color: #8E8E93;
      }

      &:before {
        margin-right: 5px;
      }

      .promoCode--success &:before {
        content: url(~@/assets/svg/icon-check.svg);
      }

      .promoCode--error &:before {
        content: url(~@/assets/svg/icon-blocked.svg);
        position: relative;
        top: 2px;
      }
    }

    &__btn {
      border: solid 1px #ff3796;
      border-radius: 20px;
      color: #ff3796;
      font-family: Oscine;
      font-size: 14px;
      font-weight: bold;
      height: 41px;
      margin-top: 16px;
      outline: 0;
      width: 100%;

      @media screen and (min-width: 375px) {
        margin-top: 32px;
        max-width: 92px;
      }

      &:disabled {
        opacity: 0.6;
      }
    }
  }
</style>
